export enum WindowBind {
  NONE = 0,

  CENTER = 1,
  LEFT = 2,
  RIGHT = 4,

  MIDDLE = 8,
  TOP = 16,
  BOTTOM = 32,

  TOP_LEFT = 18,
  MIDDLE_LEFT = 10,
  BOTTOM_LEFT = 34,

  TOP_CENTER = 17,
  MIDDLE_CENTER = 9,
  BOTTOM_CENTER = 33,

  TOP_RIGHT = 20,
  MIDDLE_RIGHT = 12,
  BOTTOM_RIGHT = 36,
}

export type WindowCoords = {
  x: number,
  y: number
};

export type WindowEdges = {
  top: number | null,
  left: number | null,
  bottom: number | null,
  right: number | null,
}

export class WindowController {
  element: HTMLDivElement | null = null;
  bind: WindowBind = WindowBind.NONE;

  constructor(bind?: WindowBind) {
    this.bind = bind || WindowBind.NONE;
  }

  setLayer (i: number) {
    if (this.element) {
      this.element.style.zIndex = `${i}`;
    }
  }

  setPosition ({ top, left, bottom, right }: WindowEdges) {
    if (this.element) {
      this.element.style.left = (left !== null ? `${left}px` : 'auto');
      this.element.style.top = (top !== null ? `${top}px` : 'auto');
      this.element.style.bottom = (bottom !== null ? `${bottom}px` : 'auto');
      this.element.style.right = (right !== null ? `${right}px` : 'auto');
    }
  }

  getPosition (): WindowEdges {
    if (this.element) {
      const top = parseFloat(this.element.style.top);
      const left = parseFloat(this.element.style.left);
      const bottom = parseFloat(this.element.style.bottom);
      const right = parseFloat(this.element.style.right);

      return {
        top: isNaN(top) ? null : top,
        left: isNaN(left) ? null : left,
        bottom: isNaN(bottom) ? null : bottom,
        right: isNaN(right) ? null : right,
      }
    }

    return {
      top: null,
      left: null,
      bottom: null,
      right: null,
    };
  }

  resize ({ x, y }: WindowCoords) {
    if (!this.element || (!x && !y)) {
      return;
    }

    const { width, height } = this.element.getBoundingClientRect();
    if (x) {
      this.element.style.width = `${width + x}px`;
    }
    if (y) {
      this.element.style.height = `${height + y}px`;
    }
  }

  hides(c: WindowController): boolean {
    if (this.element && c.element) {
      const rect1 = this.element.getBoundingClientRect();
      const rect2 = c.element.getBoundingClientRect();

      return (rect1.left <= rect2.left)
        && (rect1.right >= rect2.right)
        && (rect1.top <= rect2.top)
        && (rect1.bottom >= rect2.bottom);
    }
    return false;
  }

  getBoundingClientRect(): DOMRect | null {
    if (this.element) {
      return this.element.getBoundingClientRect();
    }
    return null;
  }
}

